<template>
  <div class="main-div">
    <section id="container" class="gnb_pdt">
      <div class="title_wrap">
        <h1 class="f_l">파우치 관리</h1>
        <div style="text-align:right; font-size:23px; float:right; line-height: 42px;">
          <button class="large_btn orange" style="width:100px; float:right; margin-left:10px;"
                  @click="onClickRefresh"
          > 새로고침
          </button>
          {{ lastRenderingTime }}
          <kendo-switch
              ref="autoYnRef"
              :messages-checked="'자동'"
              :messages-unchecked="'수동'"
              :checked="autoRender"
              @change="setAutoRender"
          >
          </kendo-switch>
        </div>
      </div>
      <div class="contents_wrap">
        <div class="content_list">
          <div class="button_wrap_area">
            <ul>
              <li>
                <button class="large_btn orange" @click="commonOnChangeEvent">검색</button>
              </li>
              <li>
                <button class="large_btn" @click="cleanFilter">초기화</button>
              </li>
            </ul>
          </div>
          <div id="filter_section" class="filter_wrap">
            <ul class="filter_list">
              <li class="col3">
                <dd>
                  <label>발신 사업장</label>
                  <ul>
                    <li>
                      <kendo-dropdownlist
                          class="w100"
                          ref="sendFacilityRef"
                          :data-source="zone1DepthListForPouch"
                          :value="lastRouteParams.sendFacility"
                          :data-text-field="'cdNm'"
                          :data-value-field="'cdId'"
                          :option-label="'전체'"
                          :no-data-template="'표시할 데이터가 없습니다.'"
                          @change="commonOnChangeEvent"
                      >
                      </kendo-dropdownlist>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>수신 사업장</label>
                  <ul>
                    <li>
                      <kendo-dropdownlist
                          class="w100"
                          ref="receiveFacilityRef"
                          :data-source="zone1DepthListForPouch"
                          :value="lastRouteParams.receiveFacility"
                          :data-text-field="'cdNm'"
                          :data-value-field="'cdId'"
                          :option-label="'전체'"
                          :no-data-template="'표시할 데이터가 없습니다.'"
                          @change="commonOnChangeEvent"
                      >
                      </kendo-dropdownlist>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>내용물</label>
                  <ul>
                    <li>
                      <kendo-dropdownlist
                          class="w100"
                          ref="contentsScnRef"
                          :data-source="pouchContentsScnList"
                          :value="lastRouteParams.contentsScn"
                          :data-text-field="'cdNm'"
                          :data-value-field="'cdId'"
                          :option-label="'전체'"
                          :no-data-template="'표시할 데이터가 없습니다.'"
                          @change="commonOnChangeEvent"
                      >
                      </kendo-dropdownlist>
                    </li>
                  </ul>
                </dd>
              </li>
              <li class="col3">
                <dd>
                  <label>발신</label>
                  <ul>
                    <li>
                      <kendo-maskedtextbox
                          class="w100"
                          id="sendNm"
                          ref="sendNmRef"
                          v-model="lastRouteParams.sendNm"
                          :placeholder="'발신 정보를 입력해주세요.'"
                      >
                      </kendo-maskedtextbox>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>수신</label>
                  <ul>
                    <li>
                      <kendo-maskedtextbox
                          class="w100"
                          id="receiveNm"
                          ref="receiveNmRef"
                          :value="lastRouteParams.receiveNm"
                          :placeholder="'수신인을 입력해주세요.'"
                      >
                      </kendo-maskedtextbox>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>등록일시</label>
                  <ul>
                    <li>
                      <div class="fl k-widget k-daterangepicker k-state-default"
                           data-role="daterangepicker"
                           role="combobox"
                           aria-expanded="false"
                           autocomplete="off">
                        <kendo-datepicker
                            ref="frstRgstDtStartDtRef"
                            :max="maxDate"
                            :value="lastRouteParams.frstRgstDtStartDt"
                            :placeholder="'년/월/일'"
                            :format="'yyyy/MM/dd'"
                            @change="commonOnChangeEvent">
                        </kendo-datepicker>
                        <span>&nbsp;</span>
                        <kendo-datepicker
                            ref="frstRgstDtEndDtRef"
                            :max="maxDate"
                            :value="lastRouteParams.frstRgstDtEndDt"
                            :placeholder="'년/월/일'"
                            :format="'yyyy/MM/dd'"
                            @change="commonOnChangeEvent">
                        </kendo-datepicker>
                      </div>
                    </li>
                  </ul>
                </dd>
              </li>
              <li class="col3">
                <dd>
                  <label>발신 시간</label>
                  <ul>
                    <li>
                      <kendo-buttongroup
                          ref="sendAmpmScnRef"
                          :index="computedSendAmpmScn"
                          :value="lastRouteParams.sendAmpmScn"
                          @select="commonOnChangeEvent"
                          :style="{width: '100%', border: '0'}">
                        <kendo-buttongroup-button
                            v-for="item in ampmScnListForList"
                            v-bind:key="item.cdId">
                          {{ item.cdNm }}
                        </kendo-buttongroup-button>
                      </kendo-buttongroup>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>수신 시간</label>
                  <ul>
                    <li>
                      <kendo-buttongroup
                          ref="receiveAmpmScnRef"
                          :index="computedReceiveAmpmScn"
                          :value="lastRouteParams.receiveAmpmScn"
                          @select="commonOnChangeEvent"
                          :style="{width: '100%', border: '0'}">
                        <kendo-buttongroup-button
                            v-for="item in ampmScnListForList"
                            v-bind:key="item.cdId">
                          {{ item.cdNm }}
                        </kendo-buttongroup-button>
                      </kendo-buttongroup>
                    </li>
                  </ul>
                </dd>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <ul class="tab mgt30">
        <li v-for="item in [{cdNm:'전체', cdId: undefined}, ...pouchStatusList]"
            :class="{on : (lastRouteParams.status === item.cdId)}"
            @click="$set(lastRouteParams, 'status', item.cdId); commonOnChangeEvent()">
        {{ item.cdNm }}
        </li>
      </ul>
      <div class="dblock mgt20">
        <div class="c_t_button_wrap f_l">
          <button class="mid_btn orange mr5" @click="onClickSave"
                  :disabled="(lastRouteParams.status !== undefined && lastRouteParams.status !== '01')"><span><span class="k-icon k-i-plus"></span>파우치 수거 등록</span>
          </button>
          <button class="mid_btn mr5" @click="onClickBatchUpdate('01', '수거 등록','사업장 이동')" :disabled="!(lastRouteParams.status === '01' || lastRouteParams.status===undefined)"><span>사업장 이동</span></button>
          <button class="mid_btn mr5" @click="onClickBatchUpdate('02', '사업장 이동', '배송 등록')" :disabled="!(lastRouteParams.status === '02' || lastRouteParams.status===undefined)"><span>배송 등록</span></button>
          <button class="mid_btn mr5" @click="onClickBatchUpdate('03', '배송 등록', '배송 완료')" :disabled="!(lastRouteParams.status === '03' || lastRouteParams.status===undefined)">
            <span>배송 완료</span></button>
          <button class="mid_btn" @click="onClickCopy"><span>복제 하기</span></button>
        </div>
        <div class="c_t_button_wrap f_r">
          <button class="mid_btn mr5" @click="$router.push({name: 'PouchBatchSave'})"><i class="download_icon"></i><span>대량 저장</span></button>
          <button class="mid_btn" @click="onClickExcelDownload"><i class="download_icon"></i><span>엑셀 다운로드</span>
          </button>
        </div>
        <div class="c_t_button_wrap f_r mgl10 mgr10">

        </div>
      </div>
      <!-- 리스트 영역 -->
      <kendo-grid ref="pouchListGridRef"
                  id="grid"
                  class="basic_table mgt10"
                  :columns="pouchListColumns"
                  :data-source="pouchListDataSource"
                  @change="onChangeEventGrid"
                  :navigatable="true"
                  :filterable="false"
                  :sortable="true"
                  :scrollable="true"
                  :pageable-always-visible="true"
                  :pageable-page-sizes="[5, 10, 20, 50, 100, 500, 1000]"
                  :reorderable="true"
                  :column-menu="false"
                  :resizable="true"
                  :selectable="'multiple row'"
                  :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }">
      </kendo-grid>
    </section>
    <get-receive-info
        ref="getReceiveInfoRef"
        :propsPouchInfo="selectedPouchInfo"
        @getReceiveInfo="getReceiveInfo"
    >
    </get-receive-info>
    <send-mail-yn
        ref="sendMailYnRef"
        :batchList="batchList"
        @afterSendMail="afterSendMail"
    ></send-mail-yn>
  </div>
</template>

<script>
import ApiConfig from "@/api/api.config";
import EtnersDateTimeUtil from "@/common/etners.datetime.util";
import EtnersParseUtil from "@/common/etners.parse.util";
import $ from "jquery";
import ApiUtil from "@/api/api.util";
import EtnersCommonUtil from "@/common/etners.common.util";
import {saveExcel} from "@progress/kendo-vue-excel-export";
import {LogisticsCodeDtlMixin, ZoneMixin} from "@/mixin/Mixin";
import GetReceiveInfo from "@/components/pouch/GetReceiveInfo";
import SendMailYn from "@/components/pouch/SendMailYn";
import app from '@/main';

export default {
  name: "PouchList",
  components: {
    SendMailYn,
    GetReceiveInfo
  },
  mixins: [LogisticsCodeDtlMixin, ZoneMixin],
  created() {
    const vm = this
    const jsonStrLastRouteParams = sessionStorage.getItem('LAST_ROUTE_PARAMS')
    vm.lastRouteParams = sessionStorage.getItem('LAST_ROUTE_NAME') === 'PouchDetail' ? (jsonStrLastRouteParams === undefined ? [] : JSON.parse(jsonStrLastRouteParams)) : []

    vm.getPouchList()
  },
  mounted() {
    const vm = this

    //엔터키 이벤트 자동 세팅
    const enterkeyEventTargetIdArray = [
      'sendNm', 'receiveNm'
    ]
    for (const elementId of enterkeyEventTargetIdArray) {
      const element = document.getElementById(elementId)
      if (element !== undefined) {
        element.onkeyup = function (e) {
          const ENTER_KEY_CODE = 'Enter'
          const NUM_PAD_ENTER = 'NumpadEnter'
          const currentKeyCode = e.code

          if (currentKeyCode === ENTER_KEY_CODE || currentKeyCode === NUM_PAD_ENTER) {
            vm.commonOnChangeEvent(e)
          }
        }
      }
    }
    vm.$refs.frstRgstDtEndDtRef.kendoWidget().value(vm.maxDate)
  },
  computed: {
    computedSendAmpmScn() {
      const vm = this
      const sendAmpmScn = vm.lastRouteParams.sendAmpmScn
      if (sendAmpmScn === undefined || sendAmpmScn === null) {
        return 0
      } else {

        if (sendAmpmScn === '01') {
          return 1
        } else if (sendAmpmScn === '02') {
          return 2
        } else {
          return 0
        }
      }
    },
    computedReceiveAmpmScn() {
      const vm = this
      const receiveAmpmScn = vm.lastRouteParams.receiveAmpmScn
      if (receiveAmpmScn === undefined || receiveAmpmScn === null) {
        return 0
      } else {

        if (receiveAmpmScn === '01') {
          return 1
        } else if (receiveAmpmScn === '02') {
          return 2
        } else {
          return 0
        }
      }
    }
  },
  methods: {
    setAutoRender() {
      const vm = this
      vm.autoRender = !vm.autoRender
      if (vm.autoRender) {
        vm.intervalSetting = window.setInterval(() => {
              vm.commonOnChangeEvent()
              vm.lastRenderingTime = EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(new Date())
            }, 300000
        );
      } else {
        window.clearInterval(vm.intervalSetting);
      }
    },
    getPouchList() {
      const vm = this
      const lastRequestParameterPage = vm.lastRouteParams.page !== undefined ? vm.lastRouteParams.page : 1
      const lastRequestParameterPageSize = vm.lastRouteParams.pageSize !== undefined ? vm.lastRouteParams.pageSize : 10

      vm.pouchListDataSource = new kendo.data.DataSource({

        name: 'pouchListDataSource',
        page: lastRequestParameterPage,
        pageSize: lastRequestParameterPageSize,
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        transport: {
          read: {
            url: `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/pouch/pouchList.json`,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            cache: false
          },
          parameterMap: function (options, operation) {
            if (operation === 'read') {

              const paramToKendoFilters = vm.currentPageFilterOption()
              const params = {
                loginUserToken: vm.loginUserToken,
                skip: options.skip,
                take: options.take,
                sort: options.sort,
                page: options.page,
                pageSize: options.pageSize,
                sendFacility: paramToKendoFilters.sendFacility,
                receiveFacility: paramToKendoFilters.receiveFacility,
                status: paramToKendoFilters.status,
                sendNm: paramToKendoFilters.sendNm,
                receiveNm: paramToKendoFilters.receiveNm,
                contentsScn: paramToKendoFilters.contentsScn,
                frstRgstDtStartDt: paramToKendoFilters.frstRgstDtStartDt,
                frstRgstDtEndDt: paramToKendoFilters.frstRgstDtEndDt,
                sendAmpmScn: paramToKendoFilters.sendAmpmScn,
                receiveAmpmScn: paramToKendoFilters.receiveAmpmScn,
                requestType: 'PAGING', // PAGING or EXPORT
              }

              sessionStorage.setItem('LAST_ROUTE_PARAMS', kendo.stringify(params))
              return kendo.stringify(params)
            }

            if (operation !== 'read' && options.models) {
              return {models: kendo.stringify(options.models)}
            }
          }
        },
        schema: {
          type: 'json',
          parse: function (response) {
            if (response.resultStatus.messageCode !== '2000') {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }

            const changeResultData = response.resultData
            let rowNumber = response.total > 1 ? response.total - ((vm.$refs.pouchListGridRef
                .dataSource.page() - 1) * vm.$refs.pouchListGridRef.dataSource.pageSize()) : response.total

            if (changeResultData === null) {
              return false
            }

            for (let i = 0; i < changeResultData.length; i++) {
              const row = changeResultData[i]
              // row 번호 내림차순 셋팅
              row.rowNumber = rowNumber--
            }

            //status 상태 값 받아오기
            response.resultData = changeResultData
            return response
          },

          total: function (response) {
            return response.total
          },

          data: function (response) {
            // 카테고리 seq 순으로 배열 선언
            if (response.resultStatus.messageCode === '2000') {
              return response.resultData
            } else {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }
          }
        },
        error: function (e) {
          // console.log('error event handler', e.errors)
        }
      })

    },
    commonOnChangeEvent() {
      const vm = this
      const gridRefs = this.$refs.pouchListGridRef

      if (gridRefs !== undefined && gridRefs.kendoWidget() !== undefined) {
        if (vm.lastRouteParams.page === undefined) {
          gridRefs.kendoWidget().dataSource.page(1)
        } else {
          gridRefs.kendoWidget().dataSource.read()
          this.lastRouteParams.page = undefined
        }
      }
    },
    cleanFilter() {
      const vm = this
      const refs = vm.$refs

      // 발신 사업장
      if (refs.sendFacilityRef !== undefined) {
        refs.sendFacilityRef.kendoWidget().select(0)
      }
      // 수신 사업장
      if (refs.receiveFacilityRef !== undefined) {
        refs.receiveFacilityRef.kendoWidget().select(0)
      }
      // 발신인
      if (refs.sendNmRef !== undefined) {
        refs.sendNmRef.kendoWidget().value('')
      }
      // 수신인
      if (refs.receiveNmRef !== undefined) {
        refs.receiveNmRef.kendoWidget().value('')
      }
      // 내용
      if (refs.contentsScnRef !== undefined) {
        refs.contentsScnRef.kendoWidget().value('')
      }
      // 등록일시
      if (refs.frstRgstDtStartDtRef !== undefined) {
        refs.frstRgstDtStartDtRef.kendoWidget().value('')
      }
      if (refs.frstRgstDtEndDtRef !== undefined) {
        refs.frstRgstDtEndDtRef.kendoWidget().value('')
      }
      // 발신 시간
      if (refs.sendAmpmScnRef !== undefined) {
        refs.sendAmpmScnRef.kendoWidget().select(0)
      }
      // 수신 시간
      if (refs.receiveAmpmScnRef !== undefined) {
        refs.receiveAmpmScnRef.kendoWidget().select(0)
      }

      vm.commonOnChangeEvent()
    },
    currentPageFilterOption() {
      const vm = this
      const refs = vm.$refs

      const currentSearchDataObj = {}

      // 발신 사업장
      if (refs.sendFacilityRef !== undefined) {
        const sendFacility = refs.sendFacilityRef.kendoWidget().value()
        if (sendFacility !== null && sendFacility !== '') {
          currentSearchDataObj.sendFacility = sendFacility
        }
      }
      // 수신 사업장
      if (refs.receiveFacilityRef !== undefined) {
        const receiveFacility = refs.receiveFacilityRef.kendoWidget().value()
        if (receiveFacility !== null && receiveFacility !== '') {
          currentSearchDataObj.receiveFacility = receiveFacility
        }
      }
      // 발신인
      if (refs.sendNmRef !== undefined) {
        const sendNm = refs.sendNmRef.kendoWidget().value()
        if (sendNm !== null && sendNm !== '') {
          currentSearchDataObj.sendNm = sendNm
        }
      }
      // 수신인
      if (refs.receiveNmRef !== undefined) {
        const receiveNm = refs.receiveNmRef.kendoWidget().value()
        if (receiveNm !== null && receiveNm !== '') {
          currentSearchDataObj.receiveNm = receiveNm
        }
      }
      // 내용
      if (refs.contentsScnRef !== undefined) {
        const contentsScn = refs.contentsScnRef.kendoWidget().value()
        if (contentsScn !== undefined && contentsScn !== '') {
          currentSearchDataObj.contentsScn = contentsScn
        }
      }
      // 등록일시
      if (refs.frstRgstDtStartDtRef !== undefined) {
        const frstRgstDtStartDt = refs.frstRgstDtStartDtRef.kendoWidget().value()
        if (frstRgstDtStartDt !== undefined && frstRgstDtStartDt !== '' && frstRgstDtStartDt !== null) {
          currentSearchDataObj.frstRgstDtStartDt = EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(frstRgstDtStartDt, '/')
        }
      }
      if (refs.frstRgstDtEndDtRef !== undefined) {
        const frstRgstDtEndDt = refs.frstRgstDtEndDtRef.kendoWidget().value()
        if (frstRgstDtEndDt !== undefined && frstRgstDtEndDt !== '' && frstRgstDtEndDt !== null) {
          currentSearchDataObj.frstRgstDtEndDt = EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(frstRgstDtEndDt, '/')
        }
      }
      // 발신 시간
      if (refs.sendAmpmScnRef !== undefined) {
        const sendAmpmScn = refs.sendAmpmScnRef.kendoWidget().current().index()
        if (sendAmpmScn !== '' && sendAmpmScn !== null) {
          currentSearchDataObj.sendAmpmScn = vm.ampmScnListForList[sendAmpmScn].cdId
        }
      }
      // 수신 시간
      if (refs.receiveAmpmScnRef !== undefined) {
        const receiveAmpmScn = refs.receiveAmpmScnRef.kendoWidget().current().index()
        if (receiveAmpmScn !== '' && receiveAmpmScn !== null) {
          currentSearchDataObj.receiveAmpmScn = vm.ampmScnListForList[receiveAmpmScn].cdId
        }
      }
      // 상태 탭
      currentSearchDataObj.status = vm.lastRouteParams.status

      return currentSearchDataObj
    },
    onClickBatchUpdate(currentStatus, fromText, toText) {
      const vm = this
      const selectedRows = vm.$refs.pouchListGridRef.kendoWidget().select()
      if (selectedRows.length === 0) {
        kendo.alert(`${toText}으로 진행할 파우치를 선택해주세요.`)
        return
      }

      // 일괄 완료 처리 대상
      let batchList = []
      for (let selectedRowValue of selectedRows) {
        const row = vm.$refs.pouchListGridRef.kendoWidget().dataItem(selectedRowValue)
        if (!vm.isSU && row.sendFacility !== vm.loginUserData.facility && row.receiveFacility !== vm.loginUserData.facility) {
          kendo.alert('소속된 사업장의 물품만 상태변경 가능합니다.')
          return
        }
        if (row.status !== currentStatus) {
          kendo.alert(`${toText} 처리는 ${fromText} 상태인 물품만 가능합니다.`)
          return
        }
        // if (row.status === '02' && row.receiveInfoYn !== 'Y') {
        //   kendo.alert(`${toText} 처리를 위해 수신정보를 입력해주세요.`)
        //   return
        // }
        batchList.push(row.pouchId)
        vm.batchList = batchList
      }

      if(currentStatus === '03') {
        // 배송 완료 처리하는 경우에만 메일 발송 여부 체크
        vm.$refs.sendMailYnRef.$refs.kendoWindowRef.kendoWidget().center().open()
      } else {
        kendo.confirm(`총 <b>${batchList.length}</b>건의 파우치를 <b>${toText}</b> 처리 하시겠습니까?`).done(function () {
          // 일괄 상태 변경 처리 api 호출
          const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/pouch/batchUpdateStatus.json`
          const params = {
            loginUserToken: vm.loginUserToken,
            pouchIdList: batchList,
            currentStatus: currentStatus
          }

          ApiUtil.post(url, params).then(response => {
            if (response.data === undefined || response.data.resultStatus === undefined) {
              kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
              return false
              const resultStatus = response.data.resultStatus
              if (resultStatus.messageCode !== '2000') {
                kendo.alert(resultStatus.messageText)
                return false
              }
            }
            const resultData = response.data.resultData
            kendo.alert(`${resultData.successCnt} 건이 ${toText} 처리 되었습니다.`)

            vm.commonOnChangeEvent()
          })
        })
      }

    },
    afterSendMail (sendMailYn) {
      const vm = this

      // 배송 등록(03) -> 배송 완료(99) 일 경우에만 해당 프로세스 진행
      let currentStatus = "03"

      // 이미 메일 발송된 후이므로, confirm 은 진행하지 않는다.
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/pouch/batchUpdateStatus.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        pouchIdList: vm.batchList,
        currentStatus: currentStatus
      }

      ApiUtil.post(url, params).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            return false
          }
        }
        const resultData = response.data.resultData
        kendo.alert(`${resultData.successCnt} 건이 배송 완료 처리 되었습니다.`)
        // if (sendMailYn === 'N') {
        //   kendo.alert(`${resultData.successCnt} 건이 배송 완료 처리 되었습니다.`)
        // } else if (sendMailYn === 'Y') {
        //   kendo.alert(`배송 완료 메일이 발송되었습니다.`)
        // }

        vm.commonOnChangeEvent()
      })
    },
    onClickExcelDownload () {
      const lastRequestParameters = JSON.parse(sessionStorage.getItem('LAST_ROUTE_PARAMS'))
      const excelParams = JSON.parse(JSON.stringify(lastRequestParameters))

      excelParams.requestType = 'EXPORT'
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/pouch/pouchList.json`

      // 로딩바 시작
      app.$Progress.plus()

      ApiUtil.post(url, excelParams).then(response => {
        let changeResultData = response.data.resultData
        if (EtnersCommonUtil.isNotEmpty(changeResultData)) {

          const currentDate = EtnersDateTimeUtil.lookupDateYYYYMMDD()
          const currentYYYYMMDD = EtnersDateTimeUtil.dateToYYYYMMDD(currentDate)

          saveExcel({
            data: changeResultData,
            fileName: `파우치관리_${currentYYYYMMDD}.xlsx`,
            columns: [
              {field: 'frstRgstDt', title: '등록일시', width: '100px',},
              {field: 'sendFacilityNm', title: '발신 사업장', width: '100px',},
              {field: 'sendNm', title: '발신', width: '100px',},
              {field: 'sendDept', title: '발신 부서', width: '100px',},
              {field: 'sendAmpmScn', title: '발신 시간', width: '100px',},
              {field: 'receiveFacilityNm', title: '수신 사업장', width: '100px',},
              {field: 'receiveNm', title: '수신', width: '100px',},
              {field: 'receiveDept', title: '수신 부서', width: '100px',},
              {field: 'receiveAmpmScnNm', title: '수신 시간', width: '100px',},
              {field: 'contentsScn', title: '내용물', width: '100px',},
              {field: 'statusNm', title: '진행 상태', width: '100px',},
              {field: 'frstRgstId', title: '최초 등록자', width: '100px',},
              {field: 'lastMdfyDt', title: '마지막 수정일시', width: '100px',},
              {field: 'lastMdfyId', title: '마지막 수정자', width: '100px',},
            ]
          })
        } else {
          app.$Progress.minus()
          kendo.alert('다운로드 할 자료가 없습니다.')
        }
        app.$Progress.minus()
      })

    },
    onChangeEventGrid (e) {
      const vm = this
      if (!([0].includes(e.sender._lastCellIndex))) {
        const selectedRow = e.sender.select()
        const item = e.sender.dataItem(selectedRow)

        const pouchId = item.pouchId
        if (pouchId !== null) {
          vm.$router.push({
            name: 'PouchDetail',
            params: {
              pouchId: pouchId
            }
          })
        }
      }
    },
    onClickSave () {
      const vm = this
      vm.$router.push({
        name: 'PouchSave'
      })
    },
    callPouchDetail (pouchId) {
      const vm = this

      const param = {
        loginUserToken: vm.loginUserToken,
        pouchId: pouchId,
      }

      const jsonUrl = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/pouch/pouchDetail.json`

      // API 호출
      return new Promise((resolve, reject) => {
        ApiUtil.post(jsonUrl, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            reject()
          }
          const resultStatus = response.data.resultStatus

          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            reject()
          }

          const resultData = response.data.resultData

          vm.selectedPouchInfo = resultData.pouchInfo
          resolve()
        })
      })

    },
    getReceiveInfo (pouchInfo) {
      const vm = this

      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/pouch/updateReceiveInfo.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        pouchId: vm.selectedPouchInfo.pouchId,
        ...pouchInfo
      }

      kendo.confirm(`해당 데이터를 수정하시겠습니까?`).done(function () {
        // 수신 정보 입력 api 호출 (배송 등록 처리를 위해선 수신 정보가 필수값이다.)
        ApiUtil.post(url, params).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }

          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            return false
          } else {
            vm.$refs.getReceiveInfoRef.$refs.kendoWindowRef.kendoWidget().close()
            kendo.alert(`수정 되었습니다.`)
            vm.commonOnChangeEvent()
          }
        })
      })
    },
    onClickRefresh () {
      const vm = this
      vm.lastRenderingTime = EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(
          new Date()
      );
      vm.$emit('refreshAll', true)
      vm.commonOnChangeEvent()
    },
    onClickCopy () {
      const vm = this
      const selectedRows = vm.$refs.pouchListGridRef.kendoWidget().select()
      if (selectedRows.length === 0) {
        kendo.alert(`복제할 파우치를 선택해주세요.`)
        return
      }
      if (selectedRows.length > 1) {
        kendo.alert(`복제할 파우치는 하나만 선택해주세요.`)
        return
      }
      const row = vm.$refs.pouchListGridRef.kendoWidget().dataItem(selectedRows[0])
      if (!vm.isSU && row.sendFacility !== vm.loginUserData.facility && row.receiveFacility !== vm.loginUserData.facility) {
        kendo.alert('소속된 사업장의 물품만 상태변경 가능합니다.')
        return
      }
      this.$router.push({
        name: "PouchUpdate",
        params: {
          pouchId : row.pouchId,
          isCopy: "Y"
        }
      })
    },
  },
  data() {
    const vm = this
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }
    const now = new Date()
    const loginUserData = JSON.parse(sessionStorage.getItem('loginUserData'))
    const isSU = loginUserData.authId === '9999'
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      loginUserData: JSON.parse(sessionStorage.getItem('loginUserData')),
      isSU: isSU,
      lastRouteParams: [],
      lastRenderingTime: EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(now),
      intervalSetting: undefined,
      autoRender: false,
      maxDate: now,

      pouchListDataSource: [],
      selectedPouchInfo: {},
      batchList: [],

      receiveDataSource: [],
      pouchListColumns: [
        {
          title: '전체선택',
          selectable: "true",
          width: "4%",
          attributes: {
            class: 'tcenter'
          },
        },
        {
          field: 'frstRgstDt',
          title: '등록일시',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendFacilityNm',
          title: '발신 사업장',
          width: '11%',
          headerAttributes: {
            'class': 'bg_green',
          },
          attributes: {
            class: 'tcenter'
          },
        },
        {
          field: 'sendNm',
          title: '발신',
          width: '9%',
          headerAttributes: {
            'class': 'bg_green',
          },
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendDept',
          title: '발신 부서',
          width: '20%',
          headerAttributes: {
            'class': 'bg_green',
          },
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendAmpmScn',
          hidden: true,
          title: '발신 시간',
          width: '6%',
          headerAttributes: {
            'class': 'bg_green',
          },
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.sendAmpmScn)
          }
        },
        {
          field: 'receiveFacilityNm',
          title: '수신 사업장',
          width: '10%',
          headerAttributes: {
            'class': 'bg_blue',
          },
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.receiveFacilityNm)
          }
        },
        {
          field: 'receiveNm',
          title: '수신',
          width: '9%',
          headerAttributes: {
            'class': 'bg_blue',
          },
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.receiveNm)
          }
        },
        {
          field: 'receiveDept',
          title: '수신 부서',
          width: '20%',
          headerAttributes: {
            'class': 'bg_blue',
          },
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.receiveDept)
          }
        },
        {
          field: 'receiveAmpmScnNm',
          title: '수신 시간',
          width: '6%',
          headerAttributes: {
            'class': 'bg_blue',
          },
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.receiveAmpmScnNm)
          }
        },
        {
          field: 'contentsScn',
          title: '내용물',
          width: '7%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.contentsScn)
          }
        },
        {
          field: 'receiveInfoYn',
          title: '필요 정보 기입 여부',
          hidden: true,
          width: '9%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template (dataItem) {
            return dataItem.receiveInfoYn
          },
          command: [
              {
                name: '수정',
                template: `<a class="k-grid-수정 pd0"><button class="btn mid_btn green" style="margin-top:-5px">입력하기</button></a>`,
                click: function (e) {
                  e.preventDefault()
                  let tr = $(e.target).closest('tr')
                  const selectedRow = this.dataItem(tr)
                  if(!vm.isSU && selectedRow.sendFacility !== vm.loginUserData.facility && selectedRow.receiveFacility !== vm.loginUserData.facility){
                    kendo.alert('소속된 사업장의 물품만 수정 가능합니다.')
                    return
                  }
                  // 수신정보 입력하기
                  vm.selectedPouchInfo = selectedRow
                  vm.callPouchDetail(selectedRow.pouchId).then(() => {
                    vm.selectedPouchInfo.receiveAmpmScn =  selectedRow.receiveAmpmScn ?? ((new Date()).getHours() < 12 ? '01' : '02')
                    vm.$refs.getReceiveInfoRef.$refs.kendoWindowRef.kendoWidget().center().open()
                  })
                },
                visible (dataItem) {
                  return !(dataItem.receiveInfoYn === 'Y')
                },
              },
              {
                name: "empty",
                template: kendo.template(`<a class='k-grid-empty'>입력 완료</a>`),
                visible: function (dataItem) {
                  return (dataItem.receiveInfoYn === 'Y')
                }
              }
          ]
        },
        {
          field: 'statusNm',
          title: '진행 상태',
          width: '8%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            let statusNm = EtnersParseUtil.convertEmptyStringToSeparator(dataItem.statusNm)
            if (dataItem.status === '01') {
              return `<span class='process01 process_icon'>${statusNm}</span>`
            } else if (dataItem.status === '02') {
              return `<span class='process02 process_icon'>${statusNm}</span>`
            } else if (dataItem.status === '03') {
              return `<span class='process03 process_icon'>${statusNm}</span>`
            } else if (dataItem.status === '99') {
              return `<span class='process08 process_icon'>${statusNm}</span>`
            }
          }
        },
      ],
    }
  },
}
</script>

<style scoped>

</style>
